<script>
    export let data, filter, change;
    $: if (!filter.func) filter.func = 'is';
    // $: change(filter);

    function onChange() {
        change(filter);
    }
</script>
{#each data as item (item)}
    <div class="col20 f-left func-option" class:active={item.func === filter.func} data-role="{item.func}">
        <label>
            <input type="radio" name="option" on:change={onChange} value="{item.func}" bind:group={filter.func}/>
            <span>{item.name}</span>
        </label>
    </div>
{/each}